module.exports = __webpack_public_path__ + "46bf65908a998afc8463f6731637683a.png";